export default __webpack_public_path__ + "static/media/NASA_01.346ee47a.png";